import React, { useLayoutEffect, useRef, useState } from 'react';
import { MdSend } from 'react-icons/md';
import { VscLoading } from 'react-icons/vsc';

const ConferenceChatInput = ({ onSend, isSending }) => {
    const [draft, setDraft] = useState('');
    const textareaRef = useRef(null);
    const submittingRef = useRef(false);

    useLayoutEffect(() => {
        const textarea = textareaRef.current;
        if (!textarea) return;
        textarea.style.height = 'auto';
        const maxHeight = parseFloat(window.getComputedStyle(textarea).maxHeight);
        textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`;
        textarea.style.overflowY = textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
    }, [draft]);

    const submitMessage = async (event) => {
        event.preventDefault();
        const message = draft.trim();
        if (!message || isSending || submittingRef.current) return;

        submittingRef.current = true;
        try {
            const sent = await onSend(message);
            if (sent) setDraft('');
        } finally {
            submittingRef.current = false;
            textareaRef.current?.focus();
        }
    };

    return (
        <form className="conferenceChatInput" onSubmit={submitMessage}>
            <textarea
                ref={textareaRef}
                aria-label="Write a channel message"
                placeholder="Message the channel…"
                value={draft}
                maxLength={5000}
                rows={1}
                readOnly={isSending}
                aria-busy={isSending}
                onChange={(event) => setDraft(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) {
                        submitMessage(event);
                    }
                }}
            />
            <button type="submit" aria-label={isSending ? 'Sending message' : 'Send message'} disabled={!draft.trim() || isSending}>
                {isSending ? (
                    <VscLoading className="spin conferenceChatInput__spinner" aria-hidden="true" />
                ) : (
                    <MdSend aria-hidden="true" />
                )}
            </button>
        </form>
    );
};

export default ConferenceChatInput;
